export default __webpack_public_path__ + "static/media/MarketRealCase.7d492909.jpg";